function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#F5F5FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6666 12C17.7666 12 18.6666 11.1 18.6666 10C18.6666 8.9 17.7666 8 16.6666 8C15.5666 8 14.6666 8.9 14.6666 10C14.6666 11.1 15.5666 12 16.6666 12ZM16.6666 14C15.5666 14 14.6666 14.9 14.6666 16C14.6666 17.1 15.5666 18 16.6666 18C17.7666 18 18.6666 17.1 18.6666 16C18.6666 14.9 17.7666 14 16.6666 14ZM14.6666 22C14.6666 20.9 15.5666 20 16.6666 20C17.7666 20 18.6666 20.9 18.6666 22C18.6666 23.1 17.7666 24 16.6666 24C15.5666 24 14.6666 23.1 14.6666 22Z",
  fill: "#121221"
});

function SvgCircularRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularRoundIcon);
export default __webpack_public_path__ + "static/media/CircularRoundIcon.1ed704cc.svg";
export { ForwardRef as ReactComponent };